module.exports = __webpack_public_path__ + "static/9-e16b4a1adefb1a4c773f14992807d7b5.jpg";